import React from 'react'
import { Text } from '@mantine/core'
import { useTheme } from '../../components/ThemeProvider'

interface ReportSectionHeadingProps {
  title: string
  index?: string
}

export default function ReportSectionHeading({ title, index }: ReportSectionHeadingProps) {
  const theme = useTheme()

  return (
    <div className="mt-4 flex items-center gap-3">
      <div
        className="flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold"
        style={{ backgroundColor: theme.primaryColor, color: theme.surfaceColor }}
      >
        {index || '—'}
      </div>
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        {title}
      </Text>
    </div>
  )
}
